(() => {
  function initHomeCustom(section) {
    if (!section || section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    const id = section.dataset.sectionId;
    const menuToggle = section.querySelector(`#menuToggle-${id}`);
    const mobileNav = section.querySelector(`#mobileNav-${id}`);
    if (menuToggle && mobileNav) {
      menuToggle.addEventListener('click', () => {
        const open = mobileNav.classList.toggle('open');
        menuToggle.setAttribute('aria-expanded', String(open));
      });
    }
    const scroller = section.querySelector(`#productScroller-${id}`);
    const prevBtn = section.querySelector(`#scrollPrev-${id}`);
    const nextBtn = section.querySelector(`#scrollNext-${id}`);
    if (scroller && prevBtn) prevBtn.addEventListener('click', () => scroller.scrollBy({left:-280,behavior:'smooth'}));
    if (scroller && nextBtn) nextBtn.addEventListener('click', () => scroller.scrollBy({left:280,behavior:'smooth'}));
    section.querySelectorAll('.add-to-bag').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.dataset.busy === 'true') return;
        const original = btn.textContent.trim();
        btn.dataset.busy = 'true';
        btn.textContent = 'Added ✓';
        setTimeout(() => { btn.textContent = original; btn.dataset.busy = 'false'; }, 1200);
      });
    });
    const qty = section.querySelector('.qty-selector');
    if (qty) {
      const b=qty.querySelectorAll('button'), v=qty.querySelector('span');
      if (b.length===2 && v) {
        b[0].addEventListener('click',()=>v.textContent=String(Math.max(1,(Number(v.textContent)||1)-1)));
        b[1].addEventListener('click',()=>v.textContent=String((Number(v.textContent)||1)+1));
      }
    }
    const tabs=section.querySelectorAll('.product-detail-tabs .tab');
    tabs.forEach(tab=>tab.addEventListener('click',()=>{tabs.forEach(x=>x.classList.remove('active'));tab.classList.add('active');}));
  }
  const initAll=()=>document.querySelectorAll('.home-custom').forEach(initHomeCustom);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAll); else initAll();
  document.addEventListener('shopify:section:load',e=>initHomeCustom(e.target.querySelector('.home-custom')));
})();
